const tracePlatformNames = {
  douyin: '抖音',
  weibo: '微博',
  xhs: '小红书',
};

export const formatTracePlatformName = (platform) => tracePlatformNames[platform] || platform;

export const formatTraceAccountName = ({ accountName, name, platform }) =>
  [formatTracePlatformName(platform), accountName || name].filter(Boolean).join('-');
